import type { Contact } from '../../../types/contact';
import type { Product } from '../../../types/product';
import type { Stock } from '../../../types/stock';

export const generateId = (): string => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
};

export interface ActivityFormData {
  feId: string; // Frontend temporary ID for UI (maps to `rid` in request)
  bid?: number; // Backend ID — present means update, absent means create
  activityTypeId?: number;
  productId?: number;
  amount?: number;
  unitPrice?: number;
  stockId?: number;
  stockFromId?: number;
  clientId?: number;
  providerId?: number;
  selectedClient?: Contact; // Store the full contact object for display
  selectedProduct?: Product; // Store the full product object for display
  selectedProvider?: Contact; // Store the full contact object for display
  selectedStock?: Stock; // Store the full stock object for display
  selectedStockFrom?: Stock; // Store the full stock object for display
  // Display-only fields, populated when loading an existing activity for editing.
  // Never sent back to the backend (buildSaveRequest whitelists fields explicitly).
  margin?: number;
  unitCostBasis?: number;
  clientOrganizationName?: string;
  providerOrganizationName?: string;
}
